export const FETCH_ONE = 'TASK.FETCH_ONE';
export const TASKUSER_CREATE = 'TASK.CREATE';
